import apiList from '@/services/index'
import $device from '@/plugin/common/device' // 全局插件 如果有很常用的就在webpackPlugin

export default {
  namespaced: true,
  state: {
    token: '',
    expiresIn: '',
    refreshToken: '',
    userinfo: {},
    storeInfo: {},
    userdata: '',
    isSubSellerAccount: '',
    storeCover: ''
  },
  getters: {
    userInfo (state) {
      return state.userinfo
    },
    storeInfo (state) {
      return state.storeInfo
    }
  },
  actions: {
    login ({ commit }, loginData) {
      const accessToken = loginData.access_token
      const refreshToken = loginData.refresh_token
      const expiresIn = loginData.expires_in
      commit('SET_TOKEN', accessToken, refreshToken, expiresIn)
      localStorage.setItem('token_key', accessToken)
      localStorage.setItem('token_expiresIn', expiresIn)
      localStorage.setItem('token_buffer', refreshToken)
    },
    getToken ({ commit }) {
      return Promise.resolve(localStorage.getItem('token_key') || '')
    },
    getRefreshToken ({ commit }) {
      return Promise.resolve(localStorage.getItem('token_buffer') || '')
    },
    getUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        apiList.user.getUserInfo().then(res => {
          if (res && parseInt(res.status) === 0) {
            const data = res.data;
            if(data.circleLeaderTag){
              data.circleLeaderTagArr = data.circleLeaderTag.split(',')
            }
            commit('SET_USERINFO', data)
            resolve(data)
          } else {
            reject(res)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    loginOut ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', {})
        $device.loginOut() // 登出
        localStorage.setItem('token_key', '')
        localStorage.setItem('token_buffer', '')
        resolve()
      })
    },
    setStoreInfo ({ commit }, storeInfo) {
      console.log(storeInfo)
      localStorage.setItem('store_info',JSON.stringify(storeInfo))
      commit('SET_STOREINFO', storeInfo)
    },
    getStoreInfo () {
      return Promise.resolve(JSON.parse(localStorage.getItem('store_info') || ''))
    },
    getinfo({
      commit
    }, storeId) {
      return new Promise((resolve, reject) => {
        apiList.user.getStoreBaseUserInfo(storeId).then(res => {
          const {
            data
          } = res.data
          commit('SET_USERDATA', data)
          commit('SET_ACCOUNT', data.isSubSellerAccount)
          commit('SET_STORECOVER', data.storeCover)
          resolve(data)
        })
      })
    }
  },
  mutations: {
    SET_TOKEN (state, token, refreshToken, expiresIn) {
      state.token = token
      state.refreshToken = refreshToken
      state.expiresIn = expiresIn
    },

    SET_USERINFO (state, userinfo) {
      state.userinfo = userinfo
    },
    SET_STOREINFO (state, storeInfo) {
      state.storeInfo = storeInfo
    },
    SET_USERDATA(state, userdata) {
      state.userdata = userdata
    },
    SET_ACCOUNT(state, isSubSellerAccount) {
      state.isSubSellerAccount = isSubSellerAccount
    },
    SET_STORECOVER(state, storeCover) {
      state.storeCover = storeCover
    }
  }
}
